export default "__VITE_ASSET__DWf6Rai3__"